import { images } from '../constants';


const process = [
    {
        id: 1,
        image: images.step1,
        title: 'Site Assessment',
        content: 'Our experts perform a detailed site assessment to evaluate solar potential and system requirements.',
    },
    {
        id: 2,
        image: images.step2,
        title: 'System Design',
        content: 'We design a customized solar energy system tailored to your energy needs and property layout.',
    },
    {
        id: 3,
        image: images.step3,
        title: 'Equipment Selection',
        content: 'Choose high-quality solar panels, inverters, and other components for optimal performance and longevity.',
    },
    {
        id: 4,
        image: images.step4,
        title: 'Installation',
        content: 'Our certified technicians install the solar system efficiently ensuring maximum energy capture.',
    },
    {
        id: 5,
        image: images.step5,
        title: 'Quality Assurance',
        content: 'We conduct rigorous testing and inspections to guarantee system reliability and safety.',
    },
    {
        id: 6,
        image: images.step6,
        title: 'Customer Support',
        content: 'We provide ongoing support and maintenance to ensure your solar energy system performs optimally.',
    },
];

export default process;